import React from 'react';

import { Box, Button, ButtonGroup, TextButton } from '@zillow/constellation';
import type { Suggestion } from '@zillow/search-box';
import { useYieldCallback } from '@zillow/yield-callback';

import type { SearchLocation } from '../../../types/searchBox';
import {
    BUYING_LISTING_BUTTON,
    RENTING_LISTING_BUTTON,
    SKIP_LISTING_BUTTON,
} from './listingButtonConfigs';
import { trackAndRedirect } from './trackAndRedirect';

export interface ListingButtonConfig {
    // callback to execute before redirect
    preCallback?: () => void;
    // search type fed to buildURL
    searchType: 'for_sale' | 'for_rent';
    // label for GA tracking
    trackingLabel: string;
    // text read on button
    displayText: string;
}
interface ListingButtonsProps {
    searchTerm: Suggestion;
    location?: SearchLocation;
}

const ListingButtons: React.FC<ListingButtonsProps> = ({ searchTerm, location }) => {
    const yieldedOnClickAction = useYieldCallback((config) =>
        trackAndRedirect(config, searchTerm, location)
    );
    return (
        <Box
            sx={{
                margin: '0 auto $spacing.xl',
                width: 210,
                maxHeight: 130,
                maxWidth: 200,
                listStyle: 'none',
            }}
        >
            <ButtonGroup direction="column" aria-label="Choose listing type">
                {[BUYING_LISTING_BUTTON, RENTING_LISTING_BUTTON].map((config) => (
                    <Button
                        key={config.displayText}
                        marginBottom="xs"
                        onClick={() => yieldedOnClickAction(config)}
                        fluid
                    >
                        {config.displayText}
                    </Button>
                ))}

                {/* Skip button */}
                <TextButton onClick={() => yieldedOnClickAction(SKIP_LISTING_BUTTON)}>
                    {SKIP_LISTING_BUTTON.displayText}
                </TextButton>
            </ButtonGroup>
        </Box>
    );
};

ListingButtons.defaultProps = {
    location: undefined,
};

export default ListingButtons;
